<!--
 * @Description: layout2 
 * @Author: 琢磨先生
 * @Date: 2022-05-08 12:54:25
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-05-08 13:28:31
-->
<template>
  <router-view></router-view>
</template>

<script>
export default {
  watch: {
    /**
     * 监听路由变化
     */
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    /**
     * 获取breadcrumb
     */
    getBreadcrumb() {
      if (
        this.$route.matched &&
        Object.keys(this.$route.matched[0].meta).length > 0
      ) {
        this.breadList = this.$route.matched;
      } else {
        this.breadList = [];
      }
    },
  },
};
</script>